// Dependecias
import axios from 'axios';

// Config
import { URL_API } from '../config/keys.config';

const token = document.querySelector<HTMLInputElement>('#access-token')!.value;
const axiosClient = axios.create({
  baseURL: URL_API,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  }
});

export async function getAllKibers({ params }:Filters) {
  try {
    const { data: { data: KiubersList } } = await axiosClient.get<ResponseHttp<Kiuber[]>>('/panel/users/kiubers', {
      params
    });

    return KiubersList;
  } catch (error) {
    console.log(error);
    return[];
  }
}

export async function getKiuberById({ params }:Filters) {
  try {
    const { data: kiuber } = await axiosClient.get<Kiuber>(`/panel/users/kiubers/${params?.id}`);

    return kiuber;
  } catch (error) {
    console.error(error);

    return undefined;
  }
}

/**
 * 
 * @param param0 
 * @returns 
 */
export async function activeOrBlockKiuber({ params }: Filters<Omit<PathParams, 'role'>>) {
  try {
    await axiosClient.patch(`/panel/users/kiubers/${params?.id}/active?active=${params?.active}`);
    return Promise.resolve();
  } catch (error) {
    console.error(error);
    return Promise.reject();
  }
}

/**
 * 
 * @param param0 
 * @returns 
 */
export async function setRoleKiuber({ params }: Filters<Omit<PathParams, 'active'>>) {
  try {
    await axiosClient.patch(`/panel/users/kiubers/${params?.id}/role?role=${params?.role}`);
    return Promise.resolve();
  } catch (error) {
    console.error(error);
    return Promise.reject();
  }
}


/**
 * 
 * @param kiuber 
 */
export async function createKiuber(kiuber: NewKiuber) {
  const { data: { data } } = await axiosClient.post<ResponseHttpCreate<{ userId: number }>>('/auth/register', kiuber);
  return data;
}

// Definición de tipos e interfaces
type Filters<T = { [key: string]: any}> = {
  params?: T
};
type PathParams = {
  id: number;
  active: '1' | '0'
  role: KiuberRoles
};
export type Kiuber = {
  id: number;
  fullname: string;
  email: string;
  role: KiuberRoles;
  active: number;
};
export type NewKiuber = {
  name: string;
  last_name: string;
  email: string;
  password: string;
  lang: string;
  phone: string;
  countryCallingCode: string;
  equipo: string;
  country: string;
};
export enum KiuberStatus {
  ACTIVE = '1',
  INACTIVE = '0'
}
export enum KiuberRoles {
  ADMIN = 'Admin',
  SQUAD = 'Squad',
  SALES = 'Ventas',
  NONE = 'None',
}
export type ResponseHttp<T> = {
  data: T;
  total: number;
  totalPages: number;
};
export type ResponseHttpCreate<T> = {
  status: number;
  response: boolean;
  message: string;
  data: T;
}